let pixelModule = null;
let initPromise = null;
let didInit = false;

const canUseWindow = () => typeof window !== 'undefined';

// Check if Facebook Pixel SDK is loaded
const isFbqAvailable = () => {
  return canUseWindow() && typeof window.fbq === 'function';
};

export function initMetaPixel() {
  if (!canUseWindow()) return Promise.resolve(false);
  if (initPromise) return initPromise;

  initPromise = import('react-facebook-pixel')
    .then(({ default: ReactPixel }) => {
      pixelModule = ReactPixel;

      const fbPixelId = process.env.REACT_APP_FB_PIXEL_ID;
      if (!fbPixelId || didInit) return Boolean(fbPixelId);

      try {
        const fbPixelAdvancedMatching = {};
        const fbPixelOptions = { autoConfig: true, debug: false };
        ReactPixel.init(fbPixelId, fbPixelAdvancedMatching, fbPixelOptions);
        ReactPixel.pageView();
        didInit = true;
        return true;
      } catch (err) {
        // Silently fail - don't disrupt customer experience
        return false;
      }
    })
    .catch(() => false);

  return initPromise;
}

/**
 * Fire-and-forget event tracking (non-blocking).
 * COMPLETELY SILENT - never disrupts customer experience.
 * If fbq is unavailable, tracking is skipped without any errors or warnings.
 */
export function trackMetaEvent(eventName, params) {
  if (!eventName) return;
  if (!canUseWindow()) return;

  // Fire-and-forget: customer experience is never blocked or disrupted
  void initMetaPixel()
    .then(() => {
      // Silently check if fbq is available - don't track if not
      if (!isFbqAvailable()) return;
      if (!pixelModule) return;
      if (typeof pixelModule.track !== 'function') return;

      try {
        if (params && typeof params === 'object') {
          pixelModule.track(eventName, params);
        } else {
          pixelModule.track(eventName);
        }
      } catch (err) {
        // Completely silent - never disrupt customer experience
      }
    })
    .catch(() => {});
}
